import { database } from "../firebase.init";

export const deleteData = async (id) => {
  return await database.ref(id).remove();
};

export const updateData = async (details, id) => {
  return await database.ref(id).update({ ...details });
};

export const appendData = async (details, rootNode) => {
  let collectionRef = database.ref(rootNode);
  let newEntryRef = collectionRef.push();
  details["id"] = newEntryRef.key;
  return await newEntryRef.set(details);
};

export const setData = async (details, rootNode) => {
  return await database.ref(rootNode).set(details);
};

export const getDataOnce = async (rootNode) => {
  let snapshot = await database.ref(rootNode).once("value");
  return snapshot?.val();
};

export const flatten = (firestoreCollection) => {
  if (!firestoreCollection) {
    return [];
  }
  return Object.keys(firestoreCollection).map(
    (key) => firestoreCollection[key]
  );
};

export const clearAll = async () => {
  return await database.ref().remove();
};
